import React from "react";
import { Link } from "react-router-dom";

export const CallforSpeakers = () => {
  return (
      <div className="visa-big-box container">
        <h5>
          IHCI 2023 invites industry leaders, researchers, practitioners, and
          experts in the field of Human-Computer Interaction (HCI) to share
          their knowledge, insights, and experiences at the conference. Here are
          the major points to consider when submitting your proposal
        </h5>
        <h4>1. Expertise</h4>
        <h5 className="information">
          We are seeking speakers who are experts in the field of HCI and have a
          deep understanding of the latest trends, technologies, and challenges
          in human-computer interaction.
        </h5>

        <h4>2. Innovative Ideas</h4>
        <h5 className="information">
          Share your innovative ideas, research findings, and case studies that
          have the potential to shape the future of HCI. We encourage speakers
          to present cutting-edge concepts and methodologies that can inspire
          the audience.
        </h5>

        <h4>3. Diverse Perspectives</h4>
        <h5 className="information">
          IHCI values diversity and encourages speakers from various
          backgrounds, including academia, industry, design, psychology, and
          engineering. We believe that diverse perspectives enrich the
          conference and contribute to a comprehensive understanding of HCI.
        </h5>

        <h4>4. Engaging Presentation Skills</h4>
        <h5 className="information">
          Speakers should have excellent presentation skills to effectively
          communicate their ideas to a diverse audience. Engaging and
          interactive sessions that encourage participation and discussion are
          highly encouraged.
        </h5>

        <h4>5. Practical Applications</h4>
        <h5 className="information">
          We welcome speakers who can showcase real-world applications of HCI
          principles and technologies. Presentations that demonstrate how HCI is
          applied to solve practical problems and improve user experiences will
          be highly regarded.
        </h5>

        <h4>6. Emerging Areas</h4>
        <h5 className="information">
          IHCI is interested in emerging areas of HCI, such as augmented
          reality, virtual reality, wearable devices, multimodal interfaces,
          intelligent user interfaces, and human-robot interaction. Speakers
          with expertise in these areas are particularly encouraged to submit
          their proposals.
        </h5>

        <h4>7. Knowledge Exchange</h4>
        <h5 className="information">
          IHCI aims to facilitate knowledge exchange and networking among
          participants. Speakers should be open to sharing their expertise,
          engaging in discussions, and collaborating with other researchers and
          practitioners.
        </h5>

        <h4>8. Duration and Format</h4>
        <h5 className="information">
          The conference offers various formats for presentations, including
          keynote speeches, panel discussions, workshops, and paper
          presentations. Please specify your preferred format and duration when
          submitting your proposal.
        </h5>

        <h4>9. Submission Guidelines</h4>
        <h5 className="information">
          To submit your proposal to the online{" "}
          <Link to="https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FIHCI2023">
            CMT
          </Link>{" "}
          site or by email: <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link>, please provide a brief
          abstract outlining your topic, key points, and the relevance of your
          presentation to the field of HCI. Include your bio, highlighting your
          qualifications and previous speaking experience.
        </h5>

        <h4>10. Deadline</h4>
        <h5 className="information">
          The deadline for speaker proposals is{" "}
          <b style={{ textDecoration: "none", color: "#FF9933" }}>
            July 15, 2023
          </b>
          . Please ensure that your submission is completed before this date.
        </h5>
        <br />
        <br />
        <h5>
          We look forward to receiving your proposals and welcoming you as a
          speaker at IHCI 2023, where we aim to foster knowledge sharing,
          collaboration, and advancement in the field of Human-Computer
          Interaction.
        </h5>
        <hr className="hr-style" />
      </div>
  );
};
